import { render, staticRenderFns } from "./UpdateDiagnostic.vue?vue&type=template&id=087979b7"
import script from "./UpdateDiagnostic.vue?vue&type=script&lang=js"
export * from "./UpdateDiagnostic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports